import { onValue, ref, DataSnapshot } from "firebase/database";
import { Observable, ReplaySubject } from "rxjs";
import { SiteEntity } from "../../models/siteEntity.model";
import firebase from "firebase/compat/app";
import Unsubscribe = firebase.Unsubscribe;

export abstract class EntitiesChannel<T extends SiteEntity> {
  private channelsUnsubscribeMap: Map<string, Unsubscribe> = new Map();

  private channelsSubscriptionValues = new ReplaySubject<T>(1);
  private partialChannelsSubscriptionValues = new ReplaySubject<T>(1);
  private updatedEntities = new ReplaySubject<T[]>(1);
  private createdEntities = new ReplaySubject<T[]>(1);

  private isCreateChannelSubscribed = false;
  private isEntityChannelSubscribed = false;
  private createdServicesUnsubscribe?: Unsubscribe;
  private entityUnsubscribe?: Unsubscribe;

  protected abstract get firebaseService(): any;
  abstract getChannelName(): String;
  abstract getPartialChannelName(): String;
  abstract getCreateChannelName(): String;

  subscribeById(id: string): void {
    const key = `full:${id}`;
    if (this.channelsUnsubscribeMap.has(key)) return;

    const { channel, database } = this.firebaseService;
    const path = `${channel.channelId}/${this.getChannelName()}/${id}`;
    const databaseReference = ref(database, path);

    const unsubscription = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
      const value = dataSnapshot.val();
      if (value) {
        this.channelsSubscriptionValues.next(value);
      }
    });

    this.channelsUnsubscribeMap.set(key, unsubscription);
  }

  subscribeByIdPartial(id: string): void {
    const key = `partial:${id}`;
    if (this.channelsUnsubscribeMap.has(key)) return;

    const { channel, database } = this.firebaseService;
    const path = `${channel.channelId}/${this.getPartialChannelName()}/${id}`;
    const databaseReference = ref(database, path);

    const unsubscription = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
      const value = dataSnapshot.val();
      if (value) {
        this.partialChannelsSubscriptionValues.next(value);
      }
    });

    this.channelsUnsubscribeMap.set(key, unsubscription);
  }

  subscribeCreateChannel(): Observable<T[]> {
    if (this.isCreateChannelSubscribed) {
      return this.createdEntities.asObservable();
    }

    this.isCreateChannelSubscribed = true;

    const { channel, database } = this.firebaseService;
    const path = `${channel.channelId}/${this.getCreateChannelName()}`;
    const databaseReference = ref(database, path);

    this.createdServicesUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
      const value = dataSnapshot.val();
      this.createdEntities.next(value || []);
    });

    return this.createdEntities.asObservable();
  }

  subscribeChannel(): Observable<T[]> {
    if (this.isEntityChannelSubscribed) {
      return this.updatedEntities.asObservable();
    }

    this.isEntityChannelSubscribed = true;

    const { channel, database } = this.firebaseService;
    const path = `${channel.channelId}/${this.getChannelName()}`;
    const databaseReference = ref(database, path);

    this.entityUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
      const value = dataSnapshot.val();
      this.updatedEntities.next(value || []);
    });

    return this.updatedEntities.asObservable();
  }

  unsubscribeCreateChannel(): void {
    this.createdServicesUnsubscribe?.();
    this.createdServicesUnsubscribe = undefined;
    this.isCreateChannelSubscribed = false;
  }

  unsubscribeChannel(): void {
    this.entityUnsubscribe?.();
    this.entityUnsubscribe = undefined;
    this.isEntityChannelSubscribed = false;
  }

  getChannelsValues(): Observable<T> {
    return this.channelsSubscriptionValues.asObservable();
  }

  getPartialChannelsValues(): Observable<T> {
    return this.partialChannelsSubscriptionValues.asObservable();
  }

  unSubscribeById(id: string): void {
    const fullKey = `full:${id}`;
    const partialKey = `partial:${id}`;

    const fullUnsub = this.channelsUnsubscribeMap.get(fullKey);
    if (fullUnsub) {
      fullUnsub();
      this.channelsUnsubscribeMap.delete(fullKey);
    }

    const partialUnsub = this.channelsUnsubscribeMap.get(partialKey);
    if (partialUnsub) {
      partialUnsub();
      this.channelsUnsubscribeMap.delete(partialKey);
    }
  }

  unSubscribeAll(): void {
    for (const [, unsubscribe] of this.channelsUnsubscribeMap) {
      unsubscribe();
    }
    this.channelsUnsubscribeMap.clear();

    this.unsubscribeChannel();
    this.unsubscribeCreateChannel();
  }
}





// import {onValue, ref} from "firebase/database";
// import {Observable, ReplaySubject} from "rxjs";
// import {SiteEntity} from "../../models/siteEntity.model";
// import firebase from "firebase/compat/app";
// import Unsubscribe = firebase.Unsubscribe;
// import {DataSnapshot} from "@firebase/database";
//
// export abstract class EntitiesChannel<T extends SiteEntity> {
//
//   private channelsUnsubscribeMap: Map<string, Unsubscribe> = new Map();
//   private channelsSubscriptionValues: ReplaySubject<T> = new ReplaySubject();
//   private partialChannelsSubscriptionValues: ReplaySubject<T> = new ReplaySubject();
//   private updatedEntities: ReplaySubject<T[]> = new ReplaySubject();
//   private createdEntities: ReplaySubject<T[]> = new ReplaySubject();
//
//   private isCreateChannelSubscribed = false;
//   private isEntityChannelSubscribed = false;
//   private createdServicesUnsubscribe: Unsubscribe;
//   private entityUnsubscribe: Unsubscribe;
//
//   protected abstract get firebaseService(): any;
//
//   abstract getChannelName(): String;
//
//   abstract getPartialChannelName(): String;
//
//   abstract getCreateChannelName(): String;
//
//
//   subscribeById(id: string): void {
//
//     if (this.channelsUnsubscribeMap.has(id)) {
//       return;
//     }
//
//
//     const channel = this.firebaseService.channel;
//     const database = this.firebaseService.database;
//
//
//     const path = `${channel.channelId}/${this.getChannelName()}/${id}`;
//     const databaseReference = ref(database, path);
//
//     const unsubscription = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//       const value = dataSnapshot.val();
//       if (!!value) {
//         this.channelsSubscriptionValues.next(value);
//       }
//     })
//
//     this.channelsUnsubscribeMap.set(id, unsubscription);
//
//   }
//
//   subscribeByIdPartial(id: string): void {
//
//     if (this.channelsUnsubscribeMap.has(id)) {
//       return;
//     }
//
//
//     const channel = this.firebaseService.channel;
//     const database = this.firebaseService.database;
//
//
//     const path = `${channel.channelId}/${this.getPartialChannelName()}/${id}`;
//     const databaseReference = ref(database, path);
//
//     const unsubscription = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//       const value = dataSnapshot.val();
//       if (!!value) {
//         this.partialChannelsSubscriptionValues.next(value);
//       }
//     })
//
//     this.channelsUnsubscribeMap.set(id, unsubscription);
//
//   }
//
//   subscribeCreateChannel(): Observable<T[]> {
//     if (this.isCreateChannelSubscribed) {
//       return this.createdEntities.asObservable();
//     }
//
//     this.isCreateChannelSubscribed = true;
//
//     const channel = this.firebaseService.channel;
//     const database = this.firebaseService.database;
//     const path = `${channel.channelId}/${this.getCreateChannelName()}`;
//     const databaseReference = ref(database, path);
//
//     this.createdServicesUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//       const value = dataSnapshot.val();
//       if (value) {
//         this.createdEntities.next(value);
//       }
//     });
//
//     return this.createdEntities.asObservable();
//   }
//
//   // subscribeCreateChannel(): Observable<T[]> {
//   //
//   //
//   //
//   //   const channel = this.firebaseService.channel;
//   //   const database = this.firebaseService.database;
//   //
//   //
//   //   const path = `${channel.channelId}/${this.getCreateChannelName()}`;
//   //   const databaseReference = ref(database, path);
//   //
//   //   this.createdServicesUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//   //     const value = dataSnapshot.val();
//   //     if (!!value) {
//   //       this.createdEntities.next(value);
//   //     }
//   //   })
//   //
//   //   return this.createdEntities.asObservable();
//   //
//   // }
//
//   // subscribeChannel(): Observable<T[]> {
//   //
//   //
//   //
//   //   const channel = this.firebaseService.channel;
//   //   const database = this.firebaseService.database;
//   //
//   //
//   //   const path = `${channel.channelId}/${this.getChannelName()}`;
//   //   const databaseReference = ref(database, path);
//   //
//   //   this.entityUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//   //     const value = dataSnapshot.val();
//   //     if (!!value) {
//   //       this.updatedEntities.next(value);
//   //     }
//   //   })
//   //
//   //   return this.updatedEntities.asObservable();
//   //
//   // }
//
//   subscribeChannel(): Observable<T[]> {
//     if (this.isEntityChannelSubscribed) {
//       return this.updatedEntities.asObservable();
//     }
//
//     this.isEntityChannelSubscribed = true;
//     console.count(`[${this.getChannelName()}] subscribeChannel called`);
//
//     const channel = this.firebaseService.channel;
//     const database = this.firebaseService.database;
//     const path = `${channel.channelId}/${this.getChannelName()}`;
//     const databaseReference = ref(database, path);
//
//     this.entityUnsubscribe = onValue(databaseReference, (dataSnapshot: DataSnapshot) => {
//       console.count(`[${this.getChannelName()}] onValue fired`);
//       const value = dataSnapshot.val();
//       if (value) {
//         this.updatedEntities.next(value);
//       }
//     });
//
//     return this.updatedEntities.asObservable();
//   }
//
//
//
//   unsubscribeCreateChannel() {
//     // this.createdServicesUnsubscribe();
//     this.createdServicesUnsubscribe?.();
//     this.createdServicesUnsubscribe = undefined;
//     this.isCreateChannelSubscribed = false;
//   }
//
//   unsubscribeChannel() {
//     // this.entityUnsubscribe();
//
//     console.count(`[${this.getChannelName()}] unsubscribeChannel called`);
//     this.entityUnsubscribe?.();
//     this.entityUnsubscribe = undefined;
//     this.isEntityChannelSubscribed = false;
//   }
//
//   getChannelsValues(): Observable<T> {
//     return this.channelsSubscriptionValues.asObservable();
//   }
//
//   getPartialChannelsValues(): Observable<T> {
//     return this.partialChannelsSubscriptionValues.asObservable();
//   }
//
//   unSubscribeById(id: string): void {
//     const channelUnsubscribe = this.channelsUnsubscribeMap.get(id);
//     if (!!channelUnsubscribe) {
//       channelUnsubscribe();
//       this.channelsUnsubscribeMap.delete(id);
//     }
//   }
//
//   unSubscribeAll(): void {
//     for (const [id, channelUnsubscribe] of this.channelsUnsubscribeMap) {
//       channelUnsubscribe();
//     }
//     this.channelsUnsubscribeMap.clear();
//   }
//
// }
